import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import FormContext from './FormContext';
import getDataLabels from './dataLabels';
import { setDataDirty as setDataDirtyAction } from '../../features/app/actions';
import { mergeUpdatedData } from './dataUtil';

class FormProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      completePpsiData: props.completePpsiData
    };
  }

  // Update status in state in case in has changed, e.g. PPSI is approved
  static getDerivedStateFromProps(props, state) {
    return mergeUpdatedData(props, state);
  }

  render() {
    const { children, dataLabels, setDataDirty } = this.props;
    const { data, completePpsiData } = this.state;

    return (
      <FormContext.Provider
        value={{
          // Data in the form.
          data,
          completePpsiData,

          // Get values of a field in the form. Argument field support paths, e.g. "ingredient.presentationName".
          getFieldValue: (field, defaultValue = '') => {
            const value = _.get(data, field, defaultValue);
            return _.isNull(value) ? '' : value;
          },

          // Set data in the form. Argument field supports paths, e.g. "info.EN-IF.presentationName".
          setFieldValue: (field, value) => {
            // console.log(field, value);
            _.set(data, field, value);
            this.setState({ data });
            if (
              data.updateNotificationList &&
              data.updateNotificationList.length
            ) {
              if (
                data.updateNotificationList
                  .map(a => a.category)
                  .includes('IFOOD_UPDATE')
              ) {
                if (
                  data.updateNotificationList.filter(
                    a =>
                      a.category === 'IFOOD_UPDATE' &&
                      a.message.includes('Discontinued')
                  ).length > 0 &&
                  data.status === 'GLOBAL APPROVED'
                ) {
                  return null;
                } else if (
                  data.updateNotificationList.filter(
                    a =>
                      a.category === 'IFOOD_UPDATE' &&
                      !a.message.includes('Discontinued')
                  ).length > 0 &&
                  data.status === 'GLOBAL APPROVED'
                ) {
                  setDataDirty();
                } else if (
                  data.updateNotificationList
                    .map(a => a.category)
                    .includes('IFOOD_UPDATE')
                ) {
                  return null;
                } else {
                  setDataDirty();
                }
                // return null;
              } else {
                if (
                  data.updateNotificationList.filter(
                    a =>
                      a.category === 'GLOBAL_PPSI_REPLACED' ||
                      a.category === 'GLOBAL_PPSI_CHANGED'
                  ).length > 0 &&
                  data.status &&
                  data.status !== 'GLOBAL APPROVED'
                ) {
                  return null;
                } else if (
                  data.updateNotificationList.filter(
                    a => a.category === 'GLOBAL_PPSI_DISCONTINUED'
                  ).length > 0 &&
                  data.status &&
                  data.status !== 'GLOBAL APPROVED'
                ) {
                  return null;
                } else {
                  setDataDirty();
                }
              }
            } else {
              setDataDirty();
            }
          },

          // Get data labels. A data label is used to display for example the presentation name as the title of the form.
          getDataLabels: language => getDataLabels(data, dataLabels, language)
        }}
      >
        {children}
      </FormContext.Provider>
    );
  }
}

export default connect(
  null,
  {
    setDataDirty: setDataDirtyAction
  }
)(FormProvider);
